import styled from '@emotion/styled';
import { Radio } from 'antd';

export const RadioGroup = styled(Radio.Group)<{ $color: string }>`
  && {
    flex-direction: row;

    .ant-radio-wrapper {
      margin: unset;

      .ant-radio.ant-wave-target {
        display: none;
      }

      .ant-radio-label {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 6rem;
        width: 9rem;
        font-size: 1.5rem;
        color: #012b27;
        border: 1px solid #012b27;
        border-radius: 6rem;
        transition: all 0.3s ease-in-out;
      }

      &:not(.ant-radio-wrapper-checked):hover {
        .ant-radio-label {
          color: #012b27;
          border: 1px solid #e6e6e6;
          background-color: #e6e6e6;
        }
      }

      &.ant-radio-wrapper-checked {
        .ant-radio-label {
          font-size: 1.75rem;
          border: 1px solid ${({ $color }) => $color};
          background-color: ${({ $color }) => $color};
        }
      }
    }

    @media (max-width: 768px) {
      flex-direction: column;

      .ant-radio-wrapper {
        .ant-radio-label {
          width: 100%;
          height: 3rem;
          font-size: 1.25rem;
          margin: 0 96px;
        }

        &.ant-radio-wrapper-checked .ant-radio-label {
          font-size: 1.375rem;
        }

        &.score-radio-option-first {
          position: relative;
          padding-top: 24px;

          &::before {
            content: '完全不知道';
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.875rem;
            line-height: 1;
            color: #00000055;
          }
        }

        &.score-radio-option-middle {
          position: relative;
          padding-bottom: 24px;

          &::before {
            content: '已有順暢的模式在進行中';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.875rem;
            line-height: 1;
            color: #00000055;
          }
        }

        &.score-radio-option-last {
          position: relative;
          padding-bottom: 24px;

          &::before {
            content: '積極實施並影響他人';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.875rem;
            line-height: 1;
            color: #00000055;
          }
        }
      }
    }

    @media (max-width: 480px) {
      .ant-radio-wrapper {
        .ant-radio-label {
          height: 2.75rem;
          font-size: 1rem;
          margin: 0 32px;
        }

        &.ant-radio-wrapper-checked .ant-radio-label {
          font-size: 1.125rem;
        }

        &.score-radio-option-first {
          padding-top: 20px;

          &::before {
            font-size: 0.75rem;
          }
        }

        &.score-radio-option-middle {
          padding-bottom: 20px;

          &::before {
            font-size: 0.75rem;
          }
        }

        &.score-radio-option-last {
          padding-bottom: 20px;

          &::before {
            font-size: 0.75rem;
          }
        }
      }
    }
  }
`;
